import API from "../axios/api"
export const listObjectives = async ()=>{
    const {data} = await API.get('api/objective/list',)
    return data
}